import { useState, useEffect, useCallback } from 'react';

export const useGetUser = (params) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useCallback(async () => {
    if (!params?.userId && !params?.username) return;

    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await fetch(`/api/users?${queryString}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch user data');
      }

      const json = await response.json();
      setData(json);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }, [params?.userId, params?.username]);

  useEffect(() => {
    fetchData();
  }, []);

  return { user: { ...data }, isLoading, refetch: fetchData };
};
